import { useEffect } from "react";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";
import Box from "@mui/material/Box";
import { colors } from "../../utils/const";
import dynamic from "next/dynamic";
import AOS from "aos";
import "aos/dist/aos.css";
import Link from "next/link";

const Title = dynamic(
  () => import("../../components/mini-components/Title.jsx"),
);

export default function Services() {
  const router = useRouter();
  const { t } = useI18n();

  useEffect(() => {
    AOS.init({
      duration: 500,
      once: false,
      mirror: true,
    });

    // Reinitialize AOS on scroll
    const handleScroll = () => {
      AOS.refresh();
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Box
      id="One-Stop-Shop"
      data-section="One-Stop-Shop"
      sx={{
        backgroundColor: "white",
      }}
    >
      <Box
        className="horizontal-safe-padding"
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "32px",
          paddingTop: { xs: "60px", md: "120px" },
          paddingBottom: { xs: "60px", md: "120px" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Title
            title={t.pages_main_tags.whyContact.services.mainTitle}
            h1={router.asPath.includes("e-payment") ? "h3" : "h2"}
          />
          <Box
            sx={{
              fontSize: { xs: "15px", sm: "15px", md: "18px" },
              textAlign: "center",
              lineHeight: "1.8",
              width: { xs: "100%", md: "650px" },
            }}
          >
            {t.pages_main_tags.whyContact.services.title}
          </Box>
        </Box>

        {/* SERVICES CONTAINER */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            gap: "24px",
          }}
        >
          {t.pages_main_tags.whyContact.services.ourServices.map((service) => (
            <Box
              key={service.id}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                borderRadius: "24px",
                padding: {
                  xs: "35px 10px",
                  sm: "48px 16px",
                },
                background: colors.light_baby_white,
                flex: {
                  xs: "1 1 calc(50% - 12px)",
                  md: "1 1 calc(33.33% - 24px)",
                },
              }}
              data-aos="fade-up"
              data-aos-delay={service.id * 500}
            >
              {/* SERVICE IMAGE */}
              <Link href={service.link} style={{ display: "inline-block" }}>
                <Box
                  component="img"
                  alt={service.text}
                  src={service.img}
                  sx={{
                    width: { xs: "60px", md: "100px" },
                    cursor: "pointer",
                  }}
                />
              </Link>

              {/* SERVICE TEXT */}
              <Link href={service.link} style={{ textDecoration: "none" }}>
                <Box
                  sx={{
                    color: service.color,
                    fontWeight: "700",
                    fontSize: { xs: "14px", sm: "16px", md: "20px" },
                    textAlign: "center",
                    cursor: "pointer",
                  }}
                >
                  {service.text}
                </Box>
              </Link>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
